<script setup>
  import Layout from "@/layouts/main.vue";
  import PageHeader from "@/components/page-header";
  import '@jobinsjp/vue3-datatable/dist/style.css';
  import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
  import moment from 'moment';
  import { truncate } from 'lodash';

  import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import Swal from 'sweetalert2';

  const store = useStore();
  const loading = computed(() => store.state.globals.loading);
  const cameras = computed(() => store.state.camera.cameras);
  const lgus = computed(() => store.state.lgu.dropdownLGUs);
  const pagination = computed(() => store.state.camera.cameraPagination);
  const title = ref("Camera Dashboard");
  const items = ref([
    {
      text: "Home",
      href: "/"
    },
    {
      text: "Camera",
    },
    {
      text: "Dashboard",
      active: true,
    }
  ])

  const isLoading = ref(false)

  const query = ref({
    search: ''        
  })

  function getLGU(id) {
    if (lgus.value.length > 0) {
      const lgu = lgus.value.find((el) => el.id === id);
      return lgu.name;
    }
    return 'N/A';
  }

  async function getAllCameras(dt) {
    isLoading.value = true

    await store.dispatch('camera/getCameras', {
      page: dt.page,
      pageSize: dt.per_page,
      sortColumn: 'updated_at',
      search: dt.search,
      orderBy: 'desc'
    });

    setTimeout(() => {
      isLoading.value = false
    }, 500)
  }


  const deleteCamera = (id, location) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
      }).then(async (result) => {
        if (result.value) {
          await store.dispatch('camera/deleteCamera', { id, location });
        }
      });
  }

  onMounted(() => {
    store.dispatch('lgu/getDropdownLGUs');
  })

  function formattedDate(date) {
    return moment(date).format('YYYY-MM-DD h:mm A')
  }
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
     <b-overlay :show="loading">
    <div class="d-flex mb-4 justify-content-between">
      <div>
        <h1 class="fs-4 text">Camera Dashboard</h1>
        <small>Lists of all cameras</small>
      </div>
      <div>
        <router-link
            to="/camera/dashboard/create"
            class="btn btn-primary right"
          >
            <i class="ri-add-fill label-icon align-middle fs-16 me-2"></i>
            New Camera
        </router-link>
      </div>
    </div>

    <div class="row">
        <div class="col lg-12">
            <data-table :rows="cameras"
                :pagination="pagination"
                striped
                :loading="isLoading"
                :query="query"
                filter
                hoverable
                sortable
                @loadData="getAllCameras"
            >
              <template #thead>
                  <table-head>Camera ID</table-head>
                  <table-head>Camera Location Name</table-head>
                  <table-head>LGU</table-head>
                  <table-head>Lanes</table-head>
                  <table-head>Status</table-head>
                  <table-head>Date Modified</table-head>
                  <table-head>Action</table-head>
              </template>

              <template #tbody="{row}">
                  <table-body v-text="row.camera_id ? row.camera_id : 'N/A'" />
                  <table-body :title="row.location">
                    {{ truncate(row.location, { length: 20 }) }}
                  </table-body>
                  <table-body v-text="getLGU(row.lgu_id)" />
                   <table-body>
                    {{ row.lanes }}
                  </table-body>
                  <table-body>
                    <b-badge :variant="row.is_enabled ? 'success' : 'danger'">
                      {{ row.is_enabled ? 'Enabled' : 'Disabled' }}
                    </b-badge>
                  </table-body>
                  <table-body>
                    {{ formattedDate(row.updated_at) }}
                  </table-body>
                  <table-body>
                     <router-link
                        :to="`/camera/dashboard/${row.id}/edit`"
                        class="btn btn-secondary mr-1"
                        title="Edit"
                      >
                      <i class="mdi mdi-pencil label-icon align-middle"></i>
                    </router-link>
                    <button
                        @click="deleteCamera(row.id, row.location)"
                        class="btn btn-danger mr-1"
                        title="Delete"
                      >
                      <i class="mdi mdi-delete label-icon align-middle"></i>
                    </button>
                  </table-body>
              </template>

              <template #empty>
                <TableBodyCell colspan="10">
                    No cameras found.
                </TableBodyCell>
            </template>
          </data-table>
        </div>
      </div>
       </b-overlay>
  </Layout>
</template>